import React, { FC } from "react";
import { Elements } from "@recurly/react-recurly";

import { useOriginInfoQuery } from "../../hooks";
import WrappedRecurlyProvider from "../../components/WrappedRecurlyProvider";
import CorporateBuy from "./components/CorporateBuy";
import { getRecurlyKey } from "../../utils/common";

export const Wrapper: FC = () => {
  const { data: originInfo } = useOriginInfoQuery();
  const recurlyPublicKey = getRecurlyKey(originInfo?.sps);

  return (
    <>
      {recurlyPublicKey && (
        <WrappedRecurlyProvider publicKey={recurlyPublicKey}>
          <Elements>
            <CorporateBuy />
          </Elements>
        </WrappedRecurlyProvider>
      )}
    </>
  );
};
